<template>
    <div class="filter-inline" v-if="invoiceTemplateList.length > 0">
        <form-group name="invoiceTemplate" label="Invoice Template">
            <md-input v-model="selectedOption" type="hidden" />
            <vue-select
                data-testid="invoice-template"
                :reduce="(r) => r"
                label="templateName"
                :options="invoiceTemplateList"
                v-model="selectedOption"
                :searchable="$root.isDesktop"
            ></vue-select>
        </form-group>
    </div>
</template>

<script>
import { PREDEFINED_INVOICE_TEMPLATES } from '@/utils/constants';

export default {
    name: 'InvoiceTemplateOptions',
    props: {
        selectedInvoiceTemplateId: {
            type: [String, Number, Object],
            default: null
        },
        customerId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            invoiceTemplateList: [],
            selectedOption: null
        };
    },
    mounted() {
        this.getInvoiceTemplates();

        if (this.selectedInvoiceTemplateId != null) {
            this.selectedOption = this.invoiceTemplateList.find(
                (x) => x.invoiceTemplateId === this.selectedInvoiceTemplateId
            );
        }
    },
    watch: {
        selectedOption(value) {
            this.$emit('selectedOption', value);
        },
        selectedInvoiceTemplateId(value) {
            if (value) {
                this.selectedOption = this.invoiceTemplateList.find((x) => x.invoiceTemplateId === value);
            } else {
                this.selectedOption = null;
            }
        }
    },
    methods: {
        getInvoiceTemplates() {
            this.invoiceTemplateList = [
                {
                    invoiceTemplateId: PREDEFINED_INVOICE_TEMPLATES.Hourly,
                    templateName: 'Hourly'
                }
            ];
        }
    }
};
</script>
